import React, { useState } from 'react';
import { Modal, Button, message } from 'antd';
import VideoTable from './VideoTable';

export const VideoAdGroupAddCreativesModal = ({
  visible,
  setVisible,
  selectedAdGroup,
  orgMedias,
  setCreativeKeys,
  updateAdGroup,
}) => {
  // Initialize with the videos already in this ad group
  const [ids, setIds] = useState(() => {
    if (selectedAdGroup?.medias) {
      return selectedAdGroup.medias.map(media => media.id);
    }
    return [];
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Update ids when modal opens with a new ad group
  React.useEffect(() => {
    if (visible && selectedAdGroup?.medias) {
      setIds(selectedAdGroup.medias.map(media => media.id));
    }
  }, [visible, selectedAdGroup]);

  const handleCancel = () => {
    setIds([]);
    if (typeof setCreativeKeys === 'function') {
      setCreativeKeys([]);
    }
    setVisible(false);
  };

  const handleOk = async () => {
    try {
      setIsSubmitting(true);

      await updateAdGroup({
        adGroup: {
          name: selectedAdGroup.name,
          medias: ids, // Just the array of IDs - updateAdGroup will format as { connect: [...] }
          id: selectedAdGroup.id,
        },
        type: 'connect',
      });

      message.success('Videos added to ad group successfully');
      handleCancel();
    } catch (error) {
      console.error("Error adding creatives:", error);
      message.error('Failed to add videos to ad group');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Modal
        title={`${selectedAdGroup?.name} - Add Videos`}
        visible={visible}
        width={1000}
        onCancel={handleCancel}
        okText="Add Videos"
        okButtonProps={{ disabled: ids.length === 0 || isSubmitting, loading: isSubmitting }}
        onOk={handleOk}
        cancelButtonProps={{ disabled: isSubmitting }}
      >
        <VideoTable
          orgMedias={orgMedias}
          setVideoCreativeKeys={setCreativeKeys}
          setVideoCreativeIds={setIds}
          videoCreativeIds={ids}
          currentPage={1}
        />
      </Modal>
    </>
  );
};
